import { createAction, props } from '@ngrx/store';

import { FactoryReducerInitialState } from '../reducers/factory.reducer';

const prefix = '[Factory]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<FactoryReducerInitialState>>()
);

export const nextStepFactoryAction = createAction(
  `${prefix} next step`,
  props<any>()
);

export const previousStepFactoryAction = createAction(
  `${prefix} previous step`
);

export const clearFactoryEntryAction = createAction(`${prefix} clear entries`);

export const clearWithLegacyFactoryEntryAction = createAction(
  `${prefix} clear legacyData`
);
